import { componentSettings as mellComponentSettings } from "../mell/componentSettings.js"

export const componentSettings = {
  banners: [
    ...mellComponentSettings.banners.filter((s) => s.type !== "bannersList"),
    { key: "banners", type: "bannersList", bannerFields: ["buttonUrl"] },
  ],
  blocks: [
    {
      key: "banners",
      type: "bannersList",
      maxItems: 2,
      bannerFields: ["buttonUrl"],
      bannerConstraints: { width: 841, height: 272 },
    },
  ],
  providersSlider: [{ key: "categories", type: "categoriesList", allowedGamesListSections: ["providers"], maxItems: 6 }],
  gamesRow: mellComponentSettings.gamesRow,
  profileButton: mellComponentSettings.profileButton,
}
